// Module
var code = "<table class=\"table report-table\">\n    <thead></thead>\n    <tfoot>\n    </tfoot>\n    <tbody></tbody>\n</table>\n";
// Exports
module.exports = code;